import { useState } from 'react'

import { Box } from '@chakra-ui/react'

import AudioPlayerInline from 'src/components/widgets/AudioPlayerInline/AudioPlayerInline'
import { VoiceTipAnalyticsProps } from 'src/lib/hooks/analytics/useAnalytics'
import { BrandColor } from 'src/types'

import CardWrapper from '../../CardWrapper/CardWrapper'

export type VoiceTipCardProps = {
  label?: string
  voiceTipUrl: string
  hasVoiceTip: boolean
  brandColor: BrandColor
  isPreview: boolean
  trackingData: VoiceTipAnalyticsProps
  itemId: number
}

const VOICE_TIP_ITEM_HEIGHT = '36px'

const VoiceTipCard: React.FC<VoiceTipCardProps> = ({
  label,
  voiceTipUrl,
  hasVoiceTip,
  brandColor,
  isPreview,
  trackingData,
  itemId,
}) => {
  const [showScrim, setShowScrim] = useState(false)
  if (!isPreview && !hasVoiceTip) return null
  return (
    <CardWrapper
      itemId={itemId}
      brandColor={brandColor}
      offScreenRender={<Box w="100%" bg="dust" h={VOICE_TIP_ITEM_HEIGHT} />}
      borderTop="1px solid"
      borderColor="dust"
      borderRadius={0}
      overflow="visible"
      py={3}
      h="56px"
      alignItems="center"
      boxShadow="none"
      direction="row"
      position="relative"
    >
      <Box
        border="2px solid"
        borderRadius="full"
        borderColor={brandColor}
        mr={2}
      />
      <Box pr={90} as="h5" className="thick" noOfLines={2}>
        {label || 'Audio Recording'}
      </Box>
      <Box
        position="absolute"
        top={0}
        right={0}
        py={3}
        bg="white"
        pl={3}
        _before={{
          content: '" "',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: '-70px',
          width: '70px',
          bg: showScrim
            ? 'linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))'
            : 'transparent',
        }}
      >
        {isPreview && !hasVoiceTip ? (
          <Box
            bg="vapor"
            color="stone"
            borderRadius="full"
            className="body-extra-small"
            py={2}
            px={4}
          >
            No Tip Yet
          </Box>
        ) : (
          <AudioPlayerInline
            mediaUrl={voiceTipUrl}
            title={label}
            brandColor={brandColor}
            showProfileImage={false}
            onPlay={() => {
              setShowScrim(true)
            }}
            onStop={() => {
              setShowScrim(false)
            }}
            showDuration={true}
            trackingData={trackingData}
          />
        )}
      </Box>
    </CardWrapper>
  )
}

export default VoiceTipCard
